<template>
  <div class="container" @click="focusInput">
    <nav-box title="换手牌" :back="false"></nav-box>
    <div class="content flex-column flex-center">
      <div class="sex flex flex-center">
        <img src="@/assets/man.png" v-if="sex == 1" alt="" />
        <img src="@/assets/woman.png" v-else alt="" />
        <span>{{ sex == 1 ? "男宾" : "女宾" }}</span>
      </div>
      <div class="code-box flex-column flex-center">
        <p class="tip">请在自助机刷房卡分配更衣柜</p>
        <div class="code">
          <img src="../../assets/swipe.png" alt="" />
        </div>
      </div>
    </div>

    <!-- 保存刷卡获取到的手牌号 -->
    <input type="text" ref="input" class="Key-card" focus v-model="KeyCard" @keyup.enter="swipingCard" />
  </div>
</template>

<script>
import navBox from "@/components/nav-box.vue";
import axios from "axios";
import moment from "moment";
export default {
  components: {
    navBox,
  },
  name: "swipe",
  data() {
    return {
      sex: 1, // 1为男宾  2为女宾
      KeyCard: "",//手牌号
    };
  },
  watch: {
    KeyCard: {
      handler: function (val, oldVal) {
        this.focusInput();
      },
      deep: true,
    },
  },
  created() {
    this.sex = this.$route.query.sex;
  },
  mounted() {
    this.focusInput();
  },
  beforeDestroy() {
  },
  methods: {
    //设置输入框焦点
    focusInput() {
      this.$refs.input.focus();
    },
    //刷卡
    swipingCard() {
      console.log(this.KeyCard)
      if (this.KeyCard) {
        this.getSingleByCode(this.KeyCard);
      }
      this.KeyCard = "";
      this.$refs.input.focus();
    },
    //获取手牌号
    getSingleByCode(code) {
      this.$fetchNo(this.Api.SingleKeyCardbycode, {code}).then(
        (res) => {
          if (res.data) {
            console.log('SingleRoomBillByCardId=', res.data)

            if(res.data.guestTypeCode=='03'){
              //換手牌
              this.changeKeyCard(res.data.code)
            }else{
              this.$toast(`在住客才能换手牌，${res.data.guestTypeName}不能换手牌`)
            }
            
          } else {
            this.$toast('找不到房卡、请重刷')
          }
        }
      );
    },
    //換手牌
    async changeKeyCard(code) {
      this.$toast.loading({
        message: "正在換手牌，请稍后....",
        forbidClick: true,
      });

      // 查询客账
      // const entryRes = await this.$fetchNo(this.Api.SelectEntryByRegId, {regId});
      // if (entryRes.data.length == 0) {
      //   this.$toast('查询客账失败')
      //   return;
      // }

      //查询手牌登记信息
      const registRes = await this.$fetchNo(this.Api.SelectRegisteredAsync, {
        pagesize:100,
        consumptionSubjectStatus: 1,
        KeyCard:code
      });
      if (registRes.data == null || registRes.data.length == 0) {
        this.$toast('此手牌已换、或者未登记   不能更换')
        return;
      }
      
      //旧的手牌信息
      const item = registRes.data[0]
      //获取新手牌
      const newKeycardRes = await this.$fetchNo(this.Api.SingleByAreaBusyStatus, {sex:this.sex});
      if (newKeycardRes.data == null) {
        this.$toast('没有可用手牌 ')
        return;
      }
      const newItem = newKeycardRes.data

      //更换手牌号
      var params = {
        consumptionAreaId: localStorage.getItem("consumptionAreaId"),
        items:[{
          consumptionSubjectId: item.consumptionSubjectId,
          entryTime: item.entryTime,
          description: item.description,
          keyCardCode: newItem.code,
          keyCardId: newItem.id,
          identificationNumber: item.identificationNumber,
          sex: this.sex,
          mobile: item.mobile,
          realName: item.realName,
          guestTypeId: item.guestTypeId,
          receptionistUserType: item.receptionistUserType || 3,
          receptionistUserId: item.receptionistUserId || "",
          receptionistRealName: item.receptionistRealName || "",
          memberCard: item.memberCard,
          comments: item.comments,
          oldKeyCardCode:item.keyCard,
          oldKeyCardId:item.keyCardId,
        }]
      };

      const updateRes = await this.$put(this.Api.Updatekeycard, params);
      console.log(updateRes)
      this.$toast.clear();

      if (updateRes.code==1) {
        this.$toast.loading({
          message: "正在打印中，请稍后....",
          forbidClick: true,
          duration: 3000,
        });

        //打印报表
        this.printReport([{keyCardNo:newItem.code,consumptionSubjectId:item.consumptionSubjectId}])
      } else {
        this.$toast('换手牌失败')
      }
    },
    //打印报表
    async printReport(list) {
      const that = this
      if (typeof Android2JS != "undefined") {
        list.forEach((item) => {
          let storeName = localStorage.getItem("storeName");
          Android2JS.Print3Lines();
          Android2JS.PrintText(storeName, 48, true);
          Android2JS.PrintText("", true);
          Android2JS.PrintText("手牌号：" + item.keyCardNo, 36, true);
          Android2JS.PrintText("打印时间：" + moment().format("YYYY/MM/DD HH:mm:ss"), 32);
          Android2JS.PrintQrcode(item.keyCardNo, 15);
          Android2JS.Print3Lines();
          Android2JS.CutPaper();
        });
      } else {
        let requestData = await this.requestUrlOrBody({ type: "P10" });
        // 打印多张离场单
        // list.forEach((item, index) => {
        //   setTimeout(() => {
        //     that.dataSet(requestData.body, [{ KeyCard: item }]);
        //   }, 3000 * (index)); // 每隔1.5秒执行一次
        // });

        axios.post(requestData.requestUrl, 
          {
            consumptionSubjectIds:list.map(item => item.consumptionSubjectId).join(","),
            keyCards:list.map(item => item.keyCardNo).join(",")
          }, 
          {
            headers: {
              access_token: this.loginToken,
              x_req_application_id: 1,
              x_req_terminal: 9,
              x_req_store_id: localStorage.getItem("storeId"),
            },
          })
          .then(function (res) {
            // 打印一张入场单
            res.data.data.dataList.forEach((item, index) => {
              setTimeout(() => {
                that.dataSet(requestData.body, [item]);
              }, 3000 * index); // 每隔1.5秒执行一次
            });
          })
          .catch(function (error) {
          });

      }
    },
    // 封装请求  返回报表请求地址和body
    // 传入获取报表类型如   {type: "P01"},
    async requestUrlOrBody(data) {
      var requestData = {
        requestUrl: "",
        body: "",
      };
      let printData = await this.$fetchNo(
        this.Api.PrintReport + "/" + data.type
      );
      requestData.body = printData.data.body;
      requestData.requestUrl = printData.data.dataInterfaceUrl;
      let reportData = await this.$fetchNo(this.Api.ReportFormat, {
        reportId: printData.data.id,
      });
      if (reportData.data.items.length > 0) {
        let list = reportData.data.items.filter((item) => item.isDefault);
        if (list.length > 0) {
          requestData.body = list[0].body;
        }
      }
      return requestData;
    },
    //数据填充打印手牌
    dataSet(body, data) {
      this.load = false;
      var that = this;
      var num = data.printCount ? data.printCount : 0;
      var invoiceAddressValue = data.invoiceAddress ? data.invoiceAddress : '';
      //创建报表对象
      var report = new window.Stimulsoft.Report.StiReport();
      // 加载文件
      report.load(body);
      //新建数据源
      var dataSet = new Stimulsoft.System.Data.DataSet("SimpleDataSet");
      //数据源填充数据
      delete data.printCount
      delete data.invoiceAddress
      dataSet.readJson(JSON.stringify(data));
      //给报表的数据源填充数据

      let hotelInfo = localStorage.getItem("hotelInfo") || "{}";
      hotelInfo = JSON.parse(hotelInfo);
      let storeName = hotelInfo.storeName || "云水荟";
      report.regData(dataSet.dataSetName, storeName, dataSet);
      var variableString = report.dictionary.variables.getByName("StoreName");
      variableString.value = storeName;
      if (num) {
        var printCount = report.dictionary.variables.getByName("printCount");
        printCount.value = num;
      }
      if (invoiceAddressValue) {
        var invoiceAddress = report.dictionary.variables.getByName("invoiceAddress");
        invoiceAddress.value = invoiceAddressValue;
      }

      // report.regBusinessObject("StoreName", "酒店名称");
      // 创建报表
      viewer.report = report;
      this.loading = true;
      setTimeout(() => {
        that.loading = false;
      }, 1200);
      report.renderAsync(async function () {
        that.loading = false;
        await report.print();
      });
    },
  },
};
</script>

<style scoped lang="less">
.container {
  position: relative;
  height: 100%;
}

.Key-card {
  position: absolute;
  z-index: -1;
}

.content {
  padding-top: 150px;

  .sex {
    margin-bottom: 100px;

    img {
      width: 200px;
      height: 200px;
    }

    span {
      font-size: 60px;
      color: #363d45;
      margin-left: 32px;
      font-weight: 500;
    }
  }

  .code-box {
    width: 850px;
    height: 950px;
    border-radius: 24px;

    .code {
      width: 850px;
      height: 850px;
      background-color: #fff;
      margin-bottom: 90px;
      border-radius: 8px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .tip {
      font-weight: 600;
      font-size: 46px;
      color: #1A1E22;
    }
  }
}
</style>